import React from 'react'

export default function Chip({ children, active, onClick, color="orange" }) {
  const bg = active
    ? color==="green" ? "bg-green-500 text-white" : "bg-[#f97316] text-white shadow-sm"
    : "bg-white text-gray-500 border border-gray-200 hover:border-[#f97316] hover:text-[#f97316]";
  return (
    <button onClick={onClick} className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-all duration-200 ${bg} whitespace-nowrap`}>{children}</button>
  );
}
